import {Component, OnInit} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-not-allowed',
  templateUrl: './not-allowed.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class NotAllowedComponent  implements OnInit{
  loading = false;
  constructor() {
  }
  ngOnInit(): void {
  }
}
